import { useEffect } from 'react';

export function useParallax() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const els = Array.from(document.querySelectorAll<HTMLElement>('[data-parallax]'));
    if (els.length === 0) return;

    let ticking = false;

    function update() {
      const vh = window.innerHeight;
      els.forEach(el => {
        const speed = parseFloat(el.dataset.parallax || '0.1');
        const r = el.getBoundingClientRect();
        const center = r.top + r.height / 2 - vh / 2;
        const offset = -center * speed;
        el.style.setProperty('--py', `${offset.toFixed(2)}px`);
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
}
